const saveReturningUserData = require(".././returningUser/saveReturningUserData");

/**
 * @param roiGateFormData {RoiGateFormData}
 * @return {void}
 */
module.exports = function saveRoiGateFormReturningUserData(roiGateFormData) {
    saveReturningUserData(roiGateFormData);
}